import { computed, ref, onMounted, onUnmounted } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-f8798180"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "table-content"
};
const _hoisted_2 = {
  class: "btn-content flex-end"
};
const _hoisted_3 = {
  class: "btn-content"
};
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = {
  key: 2,
  class: "status-content"
};
const _hoisted_6 = {
  key: 0
};
const _hoisted_7 = {
  key: 1
};
const _hoisted_8 = {
  key: 0
};
const _hoisted_9 = {
  key: 1
};
const _hoisted_10 = {
  key: 0
};
const _hoisted_11 = {
  key: 1
};
const _hoisted_12 = {
  key: 6,
  class: "price-content"
};
const _hoisted_13 = {
  class: "price"
};
const _hoisted_14 = {
  key: 7,
  class: "handle-content"
};
import { useStore } from '@/store';
import ScreenModal from '@/views/goodsManage/goodsInfo/components/ScreenModal.vue';
import RemarksModal from '@/views/goodsManage/goodsInfo/components/RemarksModal.vue';
import UploadInfoModal from '@/views/goodsManage/goodsInfo/components/UploadInfoModal.vue';
import { getGoodsInfoList } from '@/api/goodsInfo';
import { OK } from '@/common';
import { message } from 'ant-design-vue';
import useCrossPageSelection from '@/hooks/useCrossPageSelection';
export default /*#__PURE__*/_defineComponent({
  __name: 'GoodInfoTableBlock',
  setup(__props, {
    expose
  }) {
    const prodTypeList = {
      0: '未知',
      10: '非消耗型商品',
      20: '消耗型商品',
      31: '非自动续期订阅',
      32: '自动续期订阅'
    };
    const prodStatusList = {
      0: '--',
      10: '有效',
      20: '失效'
    };
    const userInfo = computed(() => useStore().userInfo && JSON.parse(useStore().userInfo));
    const columns = [{
      title: '序号',
      dataIndex: 'index',
      key: 'index',
      width: 60
    }, {
      title: '商品类型',
      dataIndex: 'prodType',
      key: 'prodType'
    }, {
      title: '内购ID',
      dataIndex: 'prodId',
      key: 'prodId',
      width: 300
    }, {
      title: '商品名称',
      dataIndex: 'prodName',
      key: 'prodName',
      width: 200
    }, {
      title: '默认价格',
      dataIndex: 'prodPrice',
      key: 'prodPrice',
      width: 120
    }, {
      title: '审核截屏',
      dataIndex: 'screenShot',
      key: 'screenShot'
    }, {
      title: '审核备注',
      dataIndex: 'auditRemarks',
      key: 'auditRemarks'
    }, {
      title: '推广图片',
      dataIndex: 'promotionPic',
      key: 'promotionPic'
    }, {
      title: '商品状态',
      dataIndex: 'prodStatus',
      key: 'prodStatus',
      width: 120
    }, {
      title: '最近同步时间',
      dataIndex: 'publishTime',
      key: 'publishTime',
      width: '160px',
      sorter: (a, b) => new Date(a.publishTime).getTime() - new Date(b.publishTime).getTime()
    }, {
      title: '最近上传时间',
      dataIndex: 'approvalSyncTime',
      key: 'approvalSyncTime',
      width: '160px',
      sorter: (a, b) => new Date(a.approvalSyncTime).getTime() - new Date(b.approvalSyncTime).getTime()
    }, {
      title: '操作',
      dataIndex: 'handle',
      key: 'handle',
      align: 'right',
      fixed: 'right'
    }];
    const useColumns = ref([]);
    const getTableHeight = () => {
      // 计算表格高度：视窗高度 - 头部导航(54px) - 面包屑(40px) - 搜索栏高度(64px) - 表格上下内边距(32px)
      // - 按钮区域高度(42px) - 分页器高度(56px) - 额外边距(20px)
      return window.innerHeight - 54 - 40 - 64 - 32 - 42 - 56 - 20 - 84;
    };
    const tableHeight = ref(getTableHeight());
    // 添加resize事件处理函数
    const handleResize = () => {
      tableHeight.value = getTableHeight();
    };
    // 生命周期钩子
    onMounted(() => {
      window.addEventListener('resize', handleResize);
      useColumns.value = columns;
    });
    onUnmounted(() => {
      window.removeEventListener('resize', handleResize);
    });
    const tableLoading = ref(false);
    const dataSource = ref([]); // 表格数据
    const {
      selectedRowKeys,
      selectedRows,
      updateSelection,
      refreshCurrentPageRows,
      clearSelection
    } = useCrossPageSelection({
      getRowKey: item => item.prodId
    });
    const pageIndex = ref(1); // 当前页
    const pageSize = ref(20); // 每页条数
    const pageTotal = ref(0); // 总条数
    const searchObj = ref({
      dbtId: '',
      prodChnl: ''
    }); // 搜索条件
    const tableRef = ref(); // 表格ref
    const screenVisible = ref(false); // 上传截屏弹窗
    const remarkVisible = ref(false); // 上传备注弹窗
    const uploadInfoVisible = ref(false); // 上传信息弹窗
    const editItem = ref({});
    let latestRequestId = 0;
    // 添加排序相关的响应式变量
    // const sortField = ref<string>('approval_sync_time')
    // const sortOrder = ref<string>('desc')
    const getData = async () => {
      const requestId = ++latestRequestId;
      const params = {
        ...searchObj.value,
        pageNum: pageIndex.value,
        pageSize: pageSize.value,
        orderByRule: 'submitApprovalOrderByRole'
      };
      dataSource.value = [];
      tableLoading.value = true;
      try {
        const {
          data,
          code
        } = await getGoodsInfoList(params);
        if (requestId !== latestRequestId) return;
        if (code === OK) {
          dataSource.value = (data === null || data === void 0 ? void 0 : data.list) || [];
          pageTotal.value = (data === null || data === void 0 ? void 0 : data.total) || 0;
          refreshCurrentPageRows(dataSource.value);
        }
      } catch (e) {} finally {
        if (requestId === latestRequestId) {
          tableLoading.value = false;
        }
      }
    }; // 获取表格数据
    const searchData = async obj => {
      clearSelection();
      pageIndex.value = 1;
      searchObj.value = obj;
      if (obj.prodChnl == 'harmony') {
        useColumns.value = columns.filter(item => item.dataIndex !== 'promotionPic');
      } else {
        useColumns.value = columns;
      }
      await getData();
    }; // 搜索
    const changePage = async (page, pageS) => {
      const sizeChanged = pageSize.value !== pageS;
      pageSize.value = pageS;
      pageIndex.value = sizeChanged ? 1 : page;
      await getData();
    }; // 分页
    const onSelectChange = (keys, rows) => {
      updateSelection(keys, rows);
    }; // 选中行
    const infomodal = ref();
    const openInfoModal = record => {
      var _infomodal$value;
      uploadInfoVisible.value = true;
      editItem.value = record;
      (_infomodal$value = infomodal.value) === null || _infomodal$value === void 0 || _infomodal$value.openModal(record);
    }; // 上传信息
    const screenmodal = ref();
    // 打开上传截屏弹窗
    const clickScreen = () => {
      var _screenmodal$value;
      if (selectedRowKeys.value.length === 0) {
        message.info('请先选择商品');
        return;
      }
      // 选择商品不超过 50 个
      if (selectedRowKeys.value.length > 50) {
        message.info('选择商品不超过 50 个');
        return;
      }
      screenVisible.value = true;
      // 根据selectedRowKeys，筛选出选中的商品
      (_screenmodal$value = screenmodal.value) === null || _screenmodal$value === void 0 || _screenmodal$value.openModal(selectedRows.value);
    };
    const remarkmodal = ref();
    // 打开上传备注弹窗
    const clickRemark = () => {
      var _remarkmodal$value;
      if (selectedRowKeys.value.length === 0) {
        message.info('请先选择商品');
        return;
      }
      remarkVisible.value = true;
      (_remarkmodal$value = remarkmodal.value) === null || _remarkmodal$value === void 0 || _remarkmodal$value.openModal(selectedRows.value);
    };
    // 批量上传截屏 / 备注后仅刷新列表，保留已勾选商品，便于连续操作
    const refreshAfterUpload = async () => {
      await getData();
    };
    const emptyTable = () => {
      clearSelection();
      pageIndex.value = 1;
      dataSource.value = [];
      pageTotal.value = 0;
    };
    expose({
      searchData,
      emptyTable
    });
    return (_ctx, _cache) => {
      var _unref2, _unref3;
      const _component_a_button = _resolveComponent("a-button");
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_a_table = _resolveComponent("a-table");
      const _component_a_pagination = _resolveComponent("a-pagination");
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_withDirectives((_openBlock(), _createBlock(_component_a_button, {
        class: "add-btn",
        onClick: clickScreen
      }, {
        default: _withCtx(() => [_createTextVNode(" 上传截屏 ")]),
        _: 1
      })), [[_directive_permission, {
        permissionValue: 'goodsJudge',
        permissionArr: (_unref2 = _unref(userInfo)) === null || _unref2 === void 0 ? void 0 : _unref2.permissions
      }]]), _withDirectives((_openBlock(), _createBlock(_component_a_button, {
        type: "primary",
        class: "add-btn",
        onClick: clickRemark
      }, {
        default: _withCtx(() => [_createTextVNode(" 上传备注 ")]),
        _: 1
      })), [[_directive_permission, {
        permissionValue: 'goodsJudge',
        permissionArr: (_unref3 = _unref(userInfo)) === null || _unref3 === void 0 ? void 0 : _unref3.permissions
      }]])])]), _createVNode(_component_a_table, {
        bordered: "",
        columns: useColumns.value,
        "data-source": dataSource.value,
        "row-key": "prodId",
        pagination: false,
        ref_key: "tableRef",
        ref: tableRef,
        "row-selection": {
          selectedRowKeys: _unref(selectedRowKeys),
          onChange: onSelectChange,
          preserveSelectedRowKeys: true
        },
        loading: tableLoading.value,
        scroll: {
          x: 2100,
          y: tableHeight.value
        }
      }, {
        bodyCell: _withCtx(({
          column,
          record,
          index
        }) => {
          var _unref4;
          return [column.dataIndex === 'index' ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString((pageIndex.value - 1) * pageSize.value + index + 1), 1)) : _createCommentVNode("", true), column.dataIndex === 'prodType' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_createTextVNode(_toDisplayString(prodTypeList[record.prodType]), 1)], 64)) : _createCommentVNode("", true), column.dataIndex === 'prodStatus' ? (_openBlock(), _createElementBlock("div", _hoisted_5, [record.prodStatus === 10 ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 0,
            "icon-class": "success",
            "class-name": "red-icon"
          })) : _createCommentVNode("", true), record.prodStatus === 20 ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 1,
            "icon-class": "outline",
            "class-name": "red-icon"
          })) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString(prodStatusList[record.prodStatus]), 1)])) : _createCommentVNode("", true), column.dataIndex === 'screenShot' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 3
          }, [record.screenShot ? (_openBlock(), _createElementBlock("span", _hoisted_6, [_createVNode(_component_svg_icon, {
            "icon-class": "success",
            "class-name": "red-icon"
          }), _createTextVNode(" 上传成功 ")])) : (_openBlock(), _createElementBlock("span", _hoisted_7, "-"))], 64)) : _createCommentVNode("", true), column.dataIndex === 'auditRemarks' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 4
          }, [record.auditRemarks ? (_openBlock(), _createElementBlock("span", _hoisted_8, [_createVNode(_component_svg_icon, {
            "icon-class": "success",
            "class-name": "red-icon"
          }), _createTextVNode(" 上传成功 ")])) : (_openBlock(), _createElementBlock("span", _hoisted_9, "-"))], 64)) : _createCommentVNode("", true), column.dataIndex === 'promotionPic' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 5
          }, [record.promotionPic ? (_openBlock(), _createElementBlock("span", _hoisted_10, [_createVNode(_component_svg_icon, {
            "icon-class": "success",
            "class-name": "red-icon"
          }), _createTextVNode(" 上传成功 ")])) : (_openBlock(), _createElementBlock("span", _hoisted_11, "-"))], 64)) : _createCommentVNode("", true), column.dataIndex === 'prodPrice' ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createElementVNode("span", _hoisted_13, _toDisplayString(record.prodPriceCurrency) + " " + _toDisplayString(record.prodPrice), 1)])) : _createCommentVNode("", true), column.dataIndex === 'handle' ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_14, [_createVNode(_component_a_button, {
            type: "link",
            onClick: $event => openInfoModal(record)
          }, {
            default: _withCtx(() => [_createTextVNode("上传信息")]),
            _: 2
          }, 1032, ["onClick"])])), [[_directive_permission, {
            permissionValue: 'goodsJudge',
            permissionArr: (_unref4 = _unref(userInfo)) === null || _unref4 === void 0 ? void 0 : _unref4.permissions
          }]]) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["columns", "data-source", "row-selection", "loading", "scroll"]), _createVNode(_component_a_pagination, {
        onChange: changePage,
        current: pageIndex.value,
        "page-size": pageSize.value,
        total: pageTotal.value,
        "show-size-changer": "",
        "show-total": total => `共 ${total} 条`
      }, null, 8, ["current", "page-size", "total", "show-total"]), _createVNode(ScreenModal, {
        "modal-visible": screenVisible.value,
        "onUpdate:modal-visible": _cache[0] || (_cache[0] = $event => screenVisible.value = $event),
        ref_key: "screenmodal",
        ref: screenmodal,
        selectedRowKeys: _unref(selectedRowKeys),
        dbtId: searchObj.value.dbtId,
        prodChnl: searchObj.value.prodChnl,
        onSearchData: refreshAfterUpload
      }, null, 8, ["modal-visible", "selectedRowKeys", "dbtId", "prodChnl"]), _createVNode(RemarksModal, {
        "modal-visible": remarkVisible.value,
        "onUpdate:modal-visible": _cache[1] || (_cache[1] = $event => remarkVisible.value = $event),
        ref_key: "remarkmodal",
        ref: remarkmodal,
        selectedRowKeys: _unref(selectedRowKeys),
        dbtId: searchObj.value.dbtId,
        prodChnl: searchObj.value.prodChnl,
        onSearchData: refreshAfterUpload
      }, null, 8, ["modal-visible", "selectedRowKeys", "dbtId", "prodChnl"]), _createVNode(UploadInfoModal, {
        "modal-visible": uploadInfoVisible.value,
        "onUpdate:modal-visible": _cache[2] || (_cache[2] = $event => uploadInfoVisible.value = $event),
        ref_key: "infomodal",
        ref: infomodal,
        dbtId: searchObj.value.dbtId,
        prodChnl: searchObj.value.prodChnl,
        onSearchData: getData
      }, null, 8, ["modal-visible", "dbtId", "prodChnl"])]);
    };
  }
});